<p class="info-text small">
  {{ 'begin_review_msg_3' | translate }}
</p>
<p class="info-text small">
  {{ 'begin_review_msg_4' | translate }}
</p>

<form [formGroup]="confirmForm">
  <div class="checkbox">
    <input type="checkbox" id="acepted-fipre" formControlName="fipre" />
    @if (!isSafari) {
      <label class="small" for="acepted-fipre"
        ><span [innerHTML]="'begin_review_acepted_fipre' | translate"></span>
        <a
          id="tooltip-fipre-diprec"
          class="icon-a"
          href="javascript:void(0)"
          tooltipEvent="focus"
          (click)="openToast('tooltip-fipre-diprec')"
          [pTooltip]="'begin_review_acepted_fipre_info' | translate"
        >
          <img class="ico-info" src="assets/img/info.svg"
        /></a>

        @if (!downloading) {
          <a class="btn btn-03 btn-fipre" (click)="downloadFIPRE()" href="javascript:void(0)">{{
            'begin_review_download' | translate
          }}</a>
        } @else {
          <a class="btn btn-03 btn-fipre disabled" href="javascript:void(0)">{{
            'begin_review_downloading' | translate
          }}</a>
        }
      </label>
    } @else {
      <label class="small" for="acepted-fipre"
        ><span [innerHTML]="'begin_review_acepted_fipre' | translate"></span>
        <a
          id="tooltip-fipre-diprec"
          class="icon-a"
          href="javascript:void(0)"
          tooltipEvent="focus"
          (click)="openToast('tooltip-fipre-diprec')"
          [pTooltip]="'begin_review_acepted_fipre_info' | translate"
        >
          <img class="ico-info" src="assets/img/info.svg"
        /></a>
        @if (urlFipre) {
          <a class="btn btn-03 btn-fipre" (click)="setDownloaded()" [href]="urlFipre" target="_blank">{{
            'begin_review_download' | translate
          }}</a>
        } @else {
          <a class="btn btn-03 btn-fipre disabled" href="javascript:void(0)">{{
            'begin_review_generate_pdf' | translate
          }}</a>
        }
      </label>
    }

    @if (confirmForm.controls['fipre'].touched && confirmForm.controls['fipre'].invalid) {
      <p class="has-error">
        {{ 'begin_review_must_acepted_document' | translate }}
      </p>
    }

    @if (msgPDFDownloaded) {
      <p class="has-error">
        {{ msgPDFDownloaded | translate }}
      </p>
    }
  </div>

  <div class="checkbox">
    <input type="checkbox" id="acepted-cirbe" formControlName="cirbe" />
    <label class="small" for="acepted-cirbe">
      {{ 'begin_review_acepted_check_cirbe' | translate }}
      <a
        id="tooltip-cirbe"
        class="icon-a"
        href="javascript:void(0)"
        tooltipEvent="focus"
        (click)="openToast('tooltip-cirbe')"
        [pTooltip]="'begin_review_acepted_check_cirbe_info' | translate"
      >
        <img class="ico-info" src="assets/img/info.svg" /></a
    ></label>
    @if (confirmForm.controls['cirbe'].touched && confirmForm.controls['cirbe'].invalid) {
      <p class="has-error">
        {{ 'begin_review_must_acepted_cirbe' | translate }}
      </p>
    }
  </div>

  <div class="row">
    <div class="col-12">
      <div class="checkbox">
        <input type="checkbox" id="login-input-politica-privacidad" formControlName="protection_clauses_1" />
        <label
          class="small"
          id="login-label-politica-privacidad"
          [class.has-error]="
            confirmForm?.controls['protection_clauses_1']?.touched &&
            !confirmForm?.controls?.protection_clauses_1?.valid
          "
          for="login-input-politica-privacidad"
        >
          <span [innerHTML]="'hipotecas_protection_clauses_privacy_policy' | translate"></span>
        </label>

        @if (
          confirmForm.controls['protection_clauses_1'].touched && !confirmForm.controls['protection_clauses_1'].valid
        ) {
          <p class="has-error">
            {{ 'hipotecas_error_politica_privadidad' | translate }}
          </p>
        }
      </div>

      <div class="row">
        <div class="col-12">
          <div class="checkbox">
            <input type="checkbox" id="login-input-informacion-precontractual" formControlName="protection_clauses_2" />
            <label
              class="small"
              id="login-label-informacion-precontractual"
              [class.has-error]="
                confirmForm?.controls['protection_clauses_2']?.touched &&
                !confirmForm?.controls?.protection_clauses_2?.valid
              "
              for="login-input-informacion-precontractual"
            >
              <span [innerHTML]="'hipotecas_protection_clauses_pre_contractual_information' | translate"></span>
              <span
                class="tooltip-inline"
                id="login-content-tooltip-protection-clauses-2"
                (click)="openToast('login-tooltip-protection-clauses-2')"
              >
                <a
                  id="login-tooltip-protection-clauses-2"
                  class="icon-a"
                  href="javascript:void(0)"
                  tooltipEvent="focus"
                  [pTooltip]="'confirm_data_sec_holder_tooltip_info_caser' | translate"
                >
                  <img class="ico-info" src="assets/img/info.svg"
                /></a>
              </span>
            </label>

            @if (
              confirmForm.controls['protection_clauses_2'].touched &&
              !confirmForm.controls['protection_clauses_2'].valid
            ) {
              <p class="has-error">
                {{ 'hipotecas_error_informacion_precontractual' | translate }}
              </p>
            }
          </div>
        </div>
      </div>
    </div>

    @if (modalComponent?.data?.error) {
      <p class="has-error">
        {{ modalComponent?.data?.error }}
      </p>
    }

    <div class="col-12 captcha">
      <button type="button" class="btn btn-02" (click)="sendForm()" id="login-btn-cont-form">
        {{ 'conform_data_sec_holder_btn_continue' | translate }}
      </button>
    </div>
  </div>
</form>
